import { useDarkMode } from '~/components/DarkMode/hook'
import { SEARCH_RESULT_TYPE, SearchResult } from '~/types/search'
import { getOperationColor } from '~/utils/shared/operationColor'

const HighlightedTitle = ({ title, searchValue } : { title: string; searchValue?: string }) => {
  if (!searchValue) {
    return title
  }

  const titleWords = title.split(' ')
  const searchValueWords = searchValue.split(' ')

  return titleWords.map((word, index) => {
    const key = `title-word-${word}-${index}`
    const isSearchValue = searchValueWords.some((searchValueWord) => {
      const searchWordTrimmed = searchValueWord.trim().toLowerCase()
      return searchWordTrimmed ? word.toLowerCase().startsWith(searchWordTrimmed) : false
    })
 
    return (
      <>
        {index > 0 && ' '}
        {isSearchValue ? (
          <span data-testid={key} key={key} className={'font-semibold bg-neutral-10 dark:bg-neutral-85'}>
            {word}
          </span>
        ) : (
          word
        )}
        {index !== titleWords.length - 1 && ' '}
      </>
    )
  })
}

export const SearchResultTileTitle = ({ result, searchValue }: { result: SearchResult; searchValue?: string }) => {
  const { isDark } = useDarkMode()

  const getTitleType = () => {
    if (result.resultType === SEARCH_RESULT_TYPE.ENDPOINT && result.method) {
      return (
        <div>
          <span style={{ color: getOperationColor(result.method, isDark()) }} className="font-semibold">
            {result.method.toUpperCase()}
          </span>
          {' / '}
          {result.summary ? <HighlightedTitle title={result.summary} searchValue={searchValue} /> : result.path?.slice(1)}
        </div>
      )
    }

    return <HighlightedTitle title={result.schemaTitle || result.schemaName || result.title} searchValue={searchValue} />
  }

  return (
    <div
      className="mb-2 font-medium break-words text-body2 text-neutral-98 dark:text-neutral-10"
      role="heading"
      aria-level={3}
    >
      {getTitleType()}
    </div>
  )
}